module.exports = __webpack_public_path__ + "img/nasa-acres.f0180eb1.png";